import {useMutation, useQueryClient} from "@tanstack/react-query";
import {KNOWLEDGE_BASE_ENDPOINTS} from "../../services/network/endpoints";
import {toast} from "react-toastify";
import {KnowledgeBaseAPI} from "../../services/network/knowledgeBase-api";

/**
 * Интерфейс для создания файла-ссылки
 */
interface CreateLinkData {
    folderId: string;
    data: {
        name: string;
        link: string;
    };
}

/**
 * Хук для создания файла-ссылки в указанной папке
 */
export function useCreateKBFileLink() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [KNOWLEDGE_BASE_ENDPOINTS.CREATE_LINK],
        mutationFn: ({folderId, data}: CreateLinkData) => KnowledgeBaseAPI.createLink(folderId, data),
        onError() {
            toast.error("Ошибка создания ссылки");
        },
        onSuccess: (_, variables) => {
            // Инвалидируем запрос на получение файлов для папки, в которой создали ссылку
            queryClient.invalidateQueries({
                queryKey: [KNOWLEDGE_BASE_ENDPOINTS.FETCH_FOLDER_FILES, variables.folderId]
            });
            
            toast.success("Ссылка успешно создана");
        }
    });
}
